// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconReviewStar_loader__zIm5E","root":"IconReviewStar_root__1uypq","filled":"IconReviewStar_filled__3_1dq"};